import "./App.css";
import { useState, useEffect } from "react";
import FloatingButton from "./components/FloatingButton";
import Header from "./components/Header";
import About from "./components/About";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Education from "./components/Education";
import Certificates from "./components/Certificates";
import Skills from "./components/Skills";

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_API_URL + "combined-data/"
        );
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  return (
    data && (
      <div
        id="top"
        className="min-h-screen font-sans bg-[#0B1D14] text-[#EDE6D6]"
      >
        <Header />
        <Hero />
        <About {...data.about} />
        <Education educationList={data.educations} />
        <Certificates CertificatesList={data.certificates} />
        <Skills {...data.skill} />
        <Projects projectList={data.projects} />
        <FloatingButton />
        <Footer />
      </div>
    )
  );
}

export default App;
